module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAdBAMAAAA9RaOJAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAIVBMVEUAh6EAfpgAWnUAgZsASmUAVG4AU24AfJYATGYAS2YAAAAPDldyAAAAAWJLR0QKaND0VgAAAAlwSFlzAAALEgAACxIB0t1+/AAAAFxJREFUKM9jYBiMgFEZSDArIokwuRowMJg5IYkwpwQzMIckI2szczUwdTNgQFEUjqoEqMgDVQkDA/uUdjT7TT1dUdUwh6QDrUNR4mZghqKIOSQY7CZ8bsb01+ABACtTDeao0mKuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/btn-close-up.png
// module id = 1508
// module chunks = 0